import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex justify-center items-center h-full-screen w-full">
      <div className="flex-column justify-center items-center">
        <img className="mb-8 w-full" src="/public/assets/images/illustrations/404.svg" alt="" />
        <p>Страница, которую вы ищите не существует или не найдена</p>
        <Link to="/">
          <Button variant="contained" color="primary" size="large">
            Вернуться на главную
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
